import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  StyledBody,
  StyledButton,
  StyledButtonDownload,
  StyledButtons,
  StyledCard,
  StyledHeading,
  StyledImage,
  StyledLabel,
  StyledLegalNotice,
  StyledProductHighlight,
  StyledText,
  StyleIcon,
} from './ProductHighlight.styled'
import { HeadingSizeEnum } from '../Heading/Heading'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import buttonVariantMacher from '../../interfaces/ButtonVariantMacher'
import NormalizeMedia from '../../utils/NormalizeMedia'
import alignmentMatcher from '../../interfaces/AligmentMatcher'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import useCtaLink from '../../hooks/useCtaLink'
import { formatSizeUnits } from '../../utils/BytesToMo'
import { getBrowser, getMobileSystem } from '../../utils/UserAgentInformations'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'
import { APP_AERO_URL, APP_AUTO_URL } from '../../config/AppAutoAero'
import { aboutUsLearnMoreEvent } from '../../utils/gtmEvents'

const ProductHighlight = (props) => {
  const { className, highlightedItems, isAboutUs, msci } = props
  const isMobile = useMediaQuery(deviceMax.mobileL)

  const browser = getBrowser()
  const mobileSystem = getMobileSystem()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])
  let block = []
  let formatDescription = ''
  for (let i = 0; i < highlightedItems.length; i++) {
    const highlight = highlightedItems[i]
    const alignment = alignmentMatcher[highlight.textAlignment]
    const docExists =
      highlight.document &&
      highlight.document.name &&
      highlight.document.cloudinary

    const hightLightUrl = highlight.cta?.urlAppAuto
      ? APP_AUTO_URL
      : highlight.cta?.urlAppAero
      ? APP_AERO_URL
      : highlight.cta?.url

    const ctaExists = highlight.cta?.label && hightLightUrl

    const [ctaUrl, ctaSlug] =
      highlight.cta && hightLightUrl ? useCtaLink(hightLightUrl) : [null, null]

    if (docExists) {
      const size = formatSizeUnits(highlight.document.cloudinary[0].bytes)
      formatDescription =
        highlight.document.cloudinary[0].format.toUpperCase() + ' - ' + size
    }

    const counterButton =
      ctaExists && docExists ? 2 : ctaExists || docExists ? 1 : 0

    const image = NormalizeMedia(highlight.image, isMobile)
    if (
      !highlight.title &&
      highlight.textHtml?.content === '' &&
      !highlight.cta &&
      !highlight.document &&
      !image
    ) {
      continue
    }
    const variant =
      highlight.buttonVariant === null
        ? ButtonVariantEnum.primary
        : buttonVariantMacher[highlight.buttonVariant]

    const handleClickEvent = (title) => {
      if (isAboutUs) {
        aboutUsLearnMoreEvent({ title })
      }
    }

    block.push(
      <StyledCard key={i + 'card'}>
        <StyledImage>{image}</StyledImage>
        <StyledBody
          key={i + 'body'}
          $hasButton={highlight.document != null || highlight.cta !== null}
        >
          {highlight.title && (
            <StyledHeading
              key={i + 'heading'}
              label={highlight.title.title}
              size={HeadingSizeEnum.h3}
            />
          )}
          {highlight.textHtml && (
            <StyledText
              key={i + 'text'}
              $alignment={alignment}
              $counterButton={counterButton}
              $hasButton={highlight.document != null || highlight.cta !== null}
              $hasTitle={highlight.title != null}
              $mobileSystem={mobileSystem}
              $browser={browser}
            >
              <CKEditorContent html={highlight.textHtml.content} />
            </StyledText>
          )}
          {(ctaExists || docExists) && (
            <StyledButtons>
              {docExists && (
                <StyledButtonDownload
                  name={highlight.document.name}
                  description={formatDescription}
                  document={highlight.document}
                  hasDownloadIcon={false}
                />
              )}
              {ctaExists && (
                <StyledButton
                  key={i + 'button'}
                  onClick={() => handleClickEvent(highlight.title.title)}
                  to={ctaSlug}
                  href={ctaUrl}
                  variant={variant}
                  target={ctaUrl && `_blank`}
                >
                  <StyledLabel key={i + 'label'}>
                    {highlight.cta?.label}
                  </StyledLabel>
                  <StyleIcon key={i + 'icon'} />
                </StyledButton>
              )}
            </StyledButtons>
          )}
        </StyledBody>
      </StyledCard>
    )
  }

  return isMounted ? (
    <StyledProductHighlight className={className}>
      {block}
      {msci && (
        <StyledLegalNotice>
          (1) The use by Constellium of any MSCI ESG Research LLC or its
          affiliates (“MSCI”) data, and the use of MSCI logos, trademarks,
          service marks or index names herein, do not constitute a sponsorship,
          endorsement, recommendation, or promotion of Constellium by MSCI. MSCI
          services and data are the property of MSCI or its information
          providers, and are provided ‘as-is’ and without warranty. MSCI names
          and logos are trademarks or service marks of MSCI.
        </StyledLegalNotice>
      )}
    </StyledProductHighlight>
  ) : null
}

ProductHighlight.propTypes = {
  highlightedItems: PropTypes.array.isRequired,
  isAboutUs: PropTypes.bool,
  msci: PropTypes.bool,
}

export default ProductHighlight
